module.exports = __webpack_public_path__ + "a85afb4f395b655da739552f5be6aa9a.png";